import { RegularExpressions } from "../../../../../../Helpers/RegularExpression";
import { ValForm, ValFormReg } from "../../../../../../Validators/ValForms";

export const ValPedidoFinanciamientoTablaAmortizacion = (state) => {
    // const vencimineto = ValForm("Vencimiento", state.vencimiento);
    console.log(state)
    const inicio = ValForm("Inicio de credito", state.inicio);
    const importe = ValFormReg(
        "Importe",
        state.importe,
        RegularExpressions.TextOnlyNumber
    );
    const plazo = ValFormReg(
        "Plazo",
        state.plazo,
        RegularExpressions.TextOnlyNumber
    );
    const tasa = ValFormReg(
        "Tasa",
        state.tasa,
        RegularExpressions.TextOnlyNumber
    );

    var isValid = true;
    var mensaje = "";
    if (inicio.isValid === false) {
        state.binicio = true;
        isValid = false;
        mensaje += inicio.mensaje;
    }
    if (importe.isValid === false) {
        state.bimporte = true;
        isValid = false;
        mensaje += importe.mensaje;
    }
    if (plazo.isValid === false) {
        state.bplazo = true;
        isValid = false;
        mensaje += plazo.mensaje;
    }
    if (tasa.isValid === false) {
        state.btasa = true;
        isValid = false;
        mensaje += tasa.mensaje;
    }

    if (isValid === false) {
        return { isValid, state, mensaje };
    } else {
        return {
            isValid,
            post: {
                folio: "",
                inicio: state.inicio,
                importe: Number(state.importe),
                plazo: Number(state.plazo),
                tasa: Number(state.tasa),
                valor_total: 0
            },
        };
    }
};
